<template>
  <ul class="com-nav">
    <li :id="'tabItem_'+item.id" @click.stop="itemClick(item)" class="tabItem" :class="[(isShowWork ? item.id === 6 : actId == item.id) && 'actived',item.showHot && 'hot']" v-for="(item,index) in navList" :key="index">
      <span :class="['iconfont', item.icon]"></span>
      <span>{{item.name}}</span>
    </li>
    <li class="tabBack flex-center" :class="navList.length && 'border'" @click="$router.go(-1)" v-if="$route.path == '/book/course'">
      <span class="iconfont fanhui"></span>返回
    </li>
    <!-- <li class="m" :style="actStyle"></li> -->
  </ul>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';
import Vue from 'vue'
import util from 'libs/util'
import helpers from 'dom-helpers';

export default {
  props: {
    actId: {
      type: [String, Number],
      default: ''
    },
    navList: {
      type: Array,
      default () {
        return []
      }
    },
    isShowWork: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    actId(newVal, oldVal) {
      if (newVal != oldVal) {
        this.calcActStyle()
      }
    }
  },
  data() {
    return {
      actStyle: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcActStyle()
    })
  },
  methods: {
    calcActStyle() {
      let actId = this.actId;
      let el = document.querySelector(`#tabItem_${actId}`);
      if (el) {
        let offset = helpers.position(el);
        let height = helpers.height(el);
        this.actStyle = {
          top: offset.top + (height - 20) / 2 + 'px'
        }
      }
    },
    itemClick(item) {
      this.$emit('itemClick', item);
    }
  }
}
</script>
<style lang="less" scoped>
@import '~styles/mixin';
@import '~styles/var';
.com-nav {
  text-align: center;
  position: relative;
  li.tabItem {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    position: relative;
    z-index: 2;
    width: 90px;
    height: 80px;
    margin: 0 auto 4px;
    border-radius: 10px;
    box-sizing: border-box;
    .iconfont {
      font-size: 32px;
      margin-bottom: 2px;
      font-weight: normal !important;
    }
    &:hover {
      color: #FB7C33;
    }
    &.actived {
      font-weight: bold;
      color: #fff;
      background: #FB7C33;
    }
    // &.m {
    //   width: 4px;
    //   height: 20px;
    //   background: #FB7C33;
    //   border-radius: 0px 100px 100px 0px;
    //   position: absolute;
    //   left: -1px;
    //   top: 0;
    //   transition: top ease .3s;
    // }
    &.hot {
      &:after {
        display: block;
        content: '';
        width: 15px;
        height: 17px;
        .bg-url('~images/hot.svg');
        background-size: 100% auto;
        right: 12px;
        top: 50%;
        position: absolute;
        transform: translate(0, -50%);
      }
    }
  }
  .tabBack {
    width: 80px;
    height: 52px;
    font-size: 14px;
    color: #666666;
    cursor: pointer;
    margin: 0 auto;
    &.border {
      border-top: 1px solid #EEEEEE;
    }
    .iconfont {
      color: #FB7C33;
      margin-right: 2px;
    }
  }
}
</style>